import React from "react";
import { motion } from "framer-motion";
import { useContactForm } from "./ContactContext";
import { PHONE_DISPLAY, PHONE_TEL } from "../config";

// Sección de contacto de las páginas de producto (car wash y parking): abre el
// formulario de cotización con el producto de la página ya puesto.
export const CarwashContact = ({ product, industry }) => {
  const { open } = useContactForm();

  return (
    <section className="py-20 px-6 lg:px-8 bg-white">
      <div className="max-w-screen-xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="max-w-2xl mx-auto text-center"
        >
          <p className="text-xs font-semibold uppercase tracking-widest text-[#1a1f6c] mb-3">Get in Touch</p>
          <h2 className="text-3xl sm:text-4xl font-bold text-[#111827] leading-tight mb-4">
            Get a quote in 24 hours
          </h2>
          <p className="text-sm sm:text-base text-[#6b7280] leading-relaxed mb-8">
            Tell us about your site. A Kinitas specialist will call you to spec the right kiosk and send a quote.
          </p>

          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              type="button"
              onClick={() => open({ intent: "quote", product, industry, source: "Get in Touch" })}
              className="px-7 py-3 rounded-lg bg-[#1a1f6c] text-white font-medium text-sm hover:bg-[#2832c2] transition-colors duration-300"
            >
              Request a Quote
            </button>
            <a
              href={PHONE_TEL}
              className="px-7 py-3 rounded-lg border border-[#1a1f6c]/25 text-[#1a1f6c] font-medium text-sm hover:bg-[#1a1f6c]/5 transition-colors duration-300"
            >
              Call {PHONE_DISPLAY}
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
